import { h } from 'preact';
import { useState } from 'preact/hooks';

const QuizPage = ({ questions, userAnswers, setUserAnswers, onFinish }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      onFinish(userAnswers);
    }
  };

  const handleAnswerChange = (event) => {
    const updatedAnswers = [...userAnswers];
    updatedAnswers[currentIndex] = event.target.value;
    setUserAnswers(updatedAnswers);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleNext();
    }
  };

  const currentQuestion = questions[currentIndex];

  return h(
    'div',
    { className: 'container' },
    h('div', { className: 'progress' },
      `問題 ${currentIndex + 1} / ${questions.length}`
    ),
    h('h2', { className: 'question' }, currentQuestion.text),
    h('input', {
      type: 'text',
      value: userAnswers[currentIndex],
      onInput: handleAnswerChange,
      onKeyPress: handleKeyPress,
      className: 'input',
      autoFocus: true,
    }),
    h(
      'button',
      { onClick: handleNext, className: 'button' },
      currentIndex < questions.length - 1 ? '次へ' : '完了'
    )
  );
};

export default QuizPage;



/** WEBPACK FOOTER **
 ** ./src/QuizPage.js
 **/